import {
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  Input,
  useDisclosure,
  FormControl,
  FormLabel,
  useToast
} from "@chakra-ui/react";
import { useState } from "react";
import axiosClient from "../../../api/axiosClient";

export default function AddEditCategoryDrawer({ onSuccess, editData = null }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [name, setName] = useState(editData?.name || "");
  const toast = useToast();

  const openDrawer = () => {
    setName(editData?.name || ""); // reset
    onOpen();
  };

  const handleSubmit = async () => {
    try {
      if (editData) {
        // UPDATE
        await axiosClient.put(`/departemen/${editData.id}`, { name });
        toast({ title: "Updated successfully", status: "success" });
      } else {
        // CREATE
        await axiosClient.post(`/departemen`, { name });
        toast({ title: "Created successfully", status: "success" });
      }

      onClose();
      if (onSuccess) onSuccess();
    } catch (error) {
      toast({ title: "Failed", status: "error" });
    }
  };

  return (
    <>
      <Button colorScheme={editData ? "yellow" : "purple"}  size="sm" onClick={openDrawer}>
        {editData ? "Edit" : "Add New"}
      </Button>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose} size="sm">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">
            {editData ? "Edit Departemen" : "Add Departemen"}
          </DrawerHeader>

          <DrawerBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Enter category name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>
          </DrawerBody>

          <DrawerFooter gap="10px">
            <Button variant="outline" onClick={onClose}>Cancel</Button>
            <Button colorScheme="purple" onClick={handleSubmit}>
              Save
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
